import { BackgroundColors, PositiveColors } from '@picsart/design-system/foundation/colors';
import { FontSizes } from '@picsart/design-system/foundation/typography';

import { createUseStyles } from 'react-jss';

import { Easing } from '@picsart/design-system/foundation/easing';
import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { Timings } from '@picsart/design-system/foundation/timings';
import { mediaQuery } from '@picsart/rc/helpers';
import { BreakPoints } from '@picsart/design-system/foundation/responsive';

type StylesProps = {
  headerHeight: number;
};

const useStyles = createUseStyles(
  {
    '@keyframes fadeIn': {
      '0% ': {
        transform: 'translateY(-100%)',
      },
      '100%': {
        transform: 'translateY(0%)',
      },
    },
    root: {
      width: '100%',
      display: 'flex',
      position: 'sticky',
      top: ({ headerHeight }: StylesProps) => headerHeight,
      left: 0,
      zIndex: 2,
      padding: [Spacings.s10, 0],
      background: PositiveColors.base.default,
      borderBottom: [1, 'solid', BackgroundColors.tint3],
      animation: `$fadeIn ${Timings.default} ${Easing.linear} both`,
    },
    wrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: Spacings.s40,
      [mediaQuery(BreakPoints.Small)]: {
        flexDirection: 'column',
        gap: Spacings.s8,
      },
    },
    left: {
      display: 'flex',
      alignItems: 'center',
      gap: Spacings.s24,
    },
    searchWrapper: {
      width: 300,
    },
    title: {
      fontSize: FontSizes.s20,
      fontWeight: FontWeights.medium,
      textTransform: 'capitalize',
    },
    contentContainer: {
      [mediaQuery(BreakPoints.Medium)]: {
        width: '75%',
      },
      '@media screen and (max-width: 768px)': {
        width: '100%',
      },
    },
  },
  {
    name: 'sticky-filter',
  },
);

export default useStyles;
